// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3v3Xw","title":"BackImages_title__1HWgI","images":"BackImages_images__lrPLq"};